module.exports = __webpack_public_path__ + "static/media/hongdanshan1.a87af81e.jpeg";